import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=2629eec4"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style0 from "./contract.vue?vue&type=style&index=0&id=2629eec4&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2629eec4')) {
      api.createRecord('2629eec4', component.options)
    } else {
      api.reload('2629eec4', component.options)
    }
    module.hot.accept("./contract.vue?vue&type=template&id=2629eec4", function () {
      api.rerender('2629eec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/remitAccount/components/contract.vue"
export default component.exports